import { ReactNode } from 'react';

import styles from './DetailsSection.module.scss';

const DetailsSection: React.FC<ReactNode> = ({ children }) => {
  return <div className={styles.detailsSection}>{children}</div>;
};

export default DetailsSection;
